import React from 'react';
import App  from './App';
import ReactDOM from 'react-dom';

export interface LiferayProps {
	properties: {
		backgroundCustomizeButtom: string | null;
		alignTextDetails: string | null;
		customizeMessage: string | null;
		textTransform: string | null;
	};
}

class WebComponent extends HTMLElement {
	connectedCallback() {
		const properties = {
			backgroundCustomizeButtom: this.getAttribute('backgroundCustomizeButtom'),
			alignTextDetails: this.getAttribute('alignTextDetails'),
			customizeMessage: this.getAttribute('customizeMessage'),
			textTransform: this.getAttribute('textTransform'),
	   	};
		ReactDOM.render(
			<App properties={properties}/>,
			this
		);
	}
}

const ELEMENT_ID = 'mf-buscador-examenes';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
